export default {
  subscribers: [],
  subscriberInfos: {
    id: null,
    mailchimp_id: null,
    email: null,
    first_name: null,
    last_name: null,
  },
  totalPages: 1
}
